<template>
  <div
    :style="{ 'box-shadow': ' 0 32px 99px' + popupValues.color }"
    class="
      finalize-popup-content
      py-4
      px-4
      d-flex
      justify-content-between
      flex-column
    "
  >
    <div class="close-btn cursor-pointer text-end">
      <span @click="close()">
        <close-svg />
      </span>
    </div>

    <div class="text-center">
      <img
        alt="save survey"
        class="img-fluid"
        :src="require(`@/assets/images/set-question/${popupValues.imgUrl}.svg`)"
      />
      <h2 class="mt-4">
        {{ popupValues.header }}
      </h2>
    </div>

    <div class="copy-url-content">
      <h5>
        {{ popupValues.description }}
      </h5>
      <div class="d-flex justify-content-between">
        <textarea
          :value="link"
          class="link"
          readonly
          rows="2"
          cols="50"
          v-on:focus="$event.target.select()"
          ref="clone"
        ></textarea>

        <span
          @click="copyURL()"
          class="copy-link font-20 cursor-pointer d-flex align-items-center"
        >
          <img
            alt="copy link"
            class="copy-link-icon me-2"
            height="40"
            src="@/assets/images/set-question/copy-link.svg"
            width="30"
          />
          <span>Copy link URL</span>
        </span>
      </div>
    </div>

    <div>
      <button
        :style="{
          'background-color': popupValues.color,
          color: popupValues.btnTextColor,
        }"
        class="w-100 p-3 text-capitalize font-20"
      >
        {{ popupValues.btnText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinalizeCardPopup",
  props: {
    popupValues: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
  methods: {
    copyURL() {
      this.$refs.clone.focus();
      document.execCommand("copy");
    },
    close() {
      this.$emit("close-popup");
    },
  },
};
</script>

<style lang="scss" scoped>
.finalize-popup-content {
  background: $color-grey-100;
  border: $border-white-1;
  border-radius: $radius-20;
  width: 751px;
  min-height: 565px;
}

h2 {
  text-align: center;
  line-height: $line-height-50;
}

button {
  border: $border-grey-60;
  border-radius: $radius-29;
  color: $color-grey-100;
}
</style>
